import React, { useEffect, useState } from "react";
import energoLogo from '../../../color-logo.svg';
import {Row, Col, Card, Button, Form, Spinner, ListGroup, ListGroupItem} from 'react-bootstrap';
import { TbFileUnknown, TbTruckDelivery } from "react-icons/tb";
import { BsPatchQuestion } from "react-icons/bs";
import HoverCard from "../../shared/HoverCard";
import PrivateApi from "../../../services/PrivateApiService";
import IconHoverBadge from "../../shared/iconHoverBadge";

/**
 * @param {customer} param bool to change logic for customer
 * @param {setSelectedInvoiceType} param string setter
 * @param {setStage} param object setter
 * @param {error} params string setter
 * 
 */

const InvoiceChoiceStage = ({customer, selectedInvoices, setSelectedInvoices, setStage, error}) => {

    const API = new PrivateApi();
    const [isSearching, setIsSearching] = useState(false);
    const [searchLoading, setSearchLoading] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [searchField, setSearchField] = useState("");


    useEffect(() => {
        if (searchField.length > 2) {
            setSearchLoading(true);
            setIsSearching(true);
            setSearchResult([]);
            API.search_Invoices(searchField)
                .then(res => {
                    let data = res.data;
                    setSearchResult(data);
                    setSearchLoading(false);
                })
                .catch(() => {
                    setSearchResult([]);
                    setSearchLoading(false);
                })
        } else {
            setIsSearching(false);
            setSearchResult([]);
        } 
    }, [searchField])


    const addInvoiceToList = (inv) => {
        if (selectedInvoices?.length > 0) {
            var index = selectedInvoices.findIndex(i => i.invoice_type === inv.invoice_type && i.id === inv.id);
            if (index === -1) setSelectedInvoices(prev => [...prev, inv]);
        
        } else {
            setSelectedInvoices([inv]);
        }
    }

    const removeInvoiceFromList = (inv) => {
        if (selectedInvoices !== null && selectedInvoices.length > 0) {
            var tmpList = selectedInvoices.filter(i => i.id !== inv.id || i.invoice_type !== inv.invoice_type);
            setSelectedInvoices(tmpList);
        }
    }
    

    return (
        <>
            <h5>Geben Sie die Rechnungsnummer ein</h5>
            <p>Bitte geben Sie hier die betroffene Rechnungsnummer an und wählen Sie "Weiter"</p>
                <Row className="mt-5" hidden={selectedInvoices === undefined || selectedInvoices === null || selectedInvoices.length === 0}>
                    <Col xs="12">
                        <p>Ausgewählte Rechnungen</p>
                        {selectedInvoices !== undefined && selectedInvoices !== null && selectedInvoices.length > 0?
                        
                        selectedInvoices.map(inv => (
                            <IconHoverBadge 
                                id={`hc-${inv.invoice_type}-${inv.id}`} 
                                key={`hc-${inv.invoice_type}-${inv.id}`} 
                                scheme={inv.invoice_type === "poolrechnung"? "energo": inv.invoice_type === "abrechnung"? "primary": "warning"}
                                icon={inv.invoice_type === "poolrechnung"? <img src={energoLogo} width={41} /> : inv.invoice_type === "abrechnung"? <TbTruckDelivery size={30} /> : <TbFileUnknown size={30} />}
                                desc={`${inv.invoice_type === "poolrechnung"? "ENERGO": inv.invoice_type === "abrechnung"? "Energielieferant": "Unbekannt"} - ${inv.x_rechnungsnummer}`} 
                                clickHandler={() => removeInvoiceFromList(inv)}
                            />
                        ))
                        :null}
                    </Col>
                </Row>

            <Row className="mt-3 justify-content-center">
                <Col xs="8">
                    <Form.Control
                        type="search"
                        value={searchField}
                        onChange={e => setSearchField(e.target.value)}
                        placeholder="Rechnungsnummer"
                    />
                    <div 
                        hidden={!isSearching}
                        className="shadow-lg" 
                        style={{border: "1px solid #ced4da", borderBottomLeftRadius: 10, borderBottomRightRadius: 10, padding: 5}}
                    >
                        {
                            isSearching && searchLoading?
                                <><span className="text-muted">Suche läuft...</span> <Spinner animation="border" className="text-energo" size="sm"/></>
                        : null}
                        {
                            searchResult !== null && searchResult.length > 0 ?
                            <ListGroup variant="flush">
                                {searchResult.map(item => (
                                    <ListGroupItem action onClick={() => addInvoiceToList(item)} key={`listGrpItem-${item.invoice_type}-${item.id}`}>
                                        <Row>
                                            <Col xs="2" className="text-center">
                                                {item.invoice_type === "poolrechnung" ?
                                                    <img src={energoLogo} width={45} /> :
                                                    <TbTruckDelivery className="text-primary" size={25} />
                                                }
                                            </Col>
                                            <Col xs="10">
                                                {item.x_rechnungsnummer}
                                            </Col>
                                        </Row>
                                    </ListGroupItem>
                                ))}
                            </ListGroup>
                        :
                            <ListGroup variant="flush">
                                <ListGroupItem>
                                    <span className="text-muted"><small>Keine Rechnungen gefunden</small></span>
                                </ListGroupItem>
                                <ListGroupItem action onClick={() => {addInvoiceToList({id: searchField, invoice_type: "unbekannt", x_rechnungsnummer: searchField, create_date: "unbekannt"}); setSearchField(""); setIsSearching(false)}}>
                                    <span className="text-energo">{searchField} übernehmen</span>
                                </ListGroupItem>
                            </ListGroup>
                        }
                    </div>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" className="text-end">
                    <Button onClick={() => setStage("default")} variant="warning">Zurück</Button> &nbsp;
                    <Button 
                        hidden={selectedInvoices === undefined || selectedInvoices === null || selectedInvoices.length === 0}
                        onClick={() => selectedInvoices !== null && selectedInvoices.length > 0? setStage("body"): null} 
                        className="btn-energo">
                            Weiter
                    </Button>
                </Col>
            </Row>
        </>
    )
}

export default InvoiceChoiceStage;